import { css } from "emotion";

export const starsBarContainer = css`
    display: flex;
    width: fit-content;
    overflow: hidden;
    cursor: pointer;
`;